import React, { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';

export default function ProtectedSection({ code, children, ...props }) {
  const { hasRight } = useContext(AuthContext);
  return hasRight(code) ? <>{children}</> : null;
}